import styled from 'styled-components'
import { Container as EmptyPageLayoutContainer } from '@layouts/EmptyPageLayout/styles'
import { minMainContainerTabletHeight } from './constants'

export const Container = styled.div`
  ${EmptyPageLayoutContainer} {
    min-height: ${minMainContainerTabletHeight}px;
  }
`
